module.exports = __webpack_public_path__ + "static/media/manzo_01_full.93d1d166.gif";